<template>
  <CatalogSelect
    :id="id"
    :is-disabled="isDisabled"
    :isCreatable="isCreatable"
    :fetchData="fetchData"
    :searchData="searchData"
    v-on="$listeners"
  >
  </CatalogSelect>
</template>

<script>
import catalogs from "../../../network/catalogs";
import CatalogSelect from "../CatalogSelect.vue";

export default {
  name: "TaskStatusSelect",
  components: { CatalogSelect },
  mixins: [ catalogs ],
  props: {
    isDisabled: { type: Boolean },
    id: { type: Number },
    isCreatable: { type: Boolean, default: true },
  },
  methods: {
    async fetchData(id) {
      return await this.getTaskStatusById(id);
    },
    async searchData(query) {
      return await this.getTaskStatusesSearch(query);
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Catalogs/TaskStatuses/TaskStatusSelect.vue